import { useContext, useMemo } from 'react'

import { ShopContext } from '@lib/shop-context'
import { StringsContext } from '@lib/strings-context'

import PriceBadge, {
  type PriceBadgeProps,
  type PriceBadgeStrings,
} from '@components/price-badge'

type ProductPriceProps = Omit<
  PriceBadgeProps,
  'currency' | 'strings' | 'taxRate'
>

const ProductPrice = (props: ProductPriceProps) => {
  const { currency, taxRate } = useContext(ShopContext)
  const strings = useContext(StringsContext)

  const priceBadgeStrings = useMemo<PriceBadgeStrings>(
    () => ({
      productDiscountText: strings.productDiscountText,
      productPricePrefix: strings.productPricePrefix,
      productTaxIncludedText: strings.productTaxIncludedText,
    }),
    [strings],
  )

  return (
    <PriceBadge
      {...props}
      strings={priceBadgeStrings}
      currency={currency}
      taxRate={taxRate}
    />
  )
}

export default ProductPrice
